import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'

const style = {
  grid: {
    //top right bottom left,
    padding: '0 10px 0 0 !important'
    // padding: '0 15px !important' // this is for grid
    // This height value screw things up in xs, seems somehow the entire containder only have height from one griditem
    //height: '35px'

    //height: '20vh'
  },
  gridWithBorder: {
    padding: '0 10px 0 0 !important',
    border: '1px solid yellow'
  }
}

function GridItemCondense({ ...props }) {
  const { classes, children, className, border, ...rest } = props
  const r = border ? (
    <Grid item {...rest} className={classes.gridWithBorder + ' ' + className}>
      {children}
    </Grid>
  ) : (
    <Grid item {...rest} className={classes.grid + ' ' + className}>
      {children}
    </Grid>
  )
  return r
}

export default withStyles(style)(GridItemCondense)
